import React from "react";
import { Icon, Paragraph, useTheme, useColorTokens } from "@tvg/design-system";
import { animated, useTransition, useSpring } from "@react-spring/web";
import { BackButton, BackTextContainer, Container } from "./styled-components";
import List from "../List";
import { MenuProps } from "../types";

const AnimatedContainer = animated(Container);
const AnimatedBackButton = animated(BackButton);
const AnimatedList = animated(List);

const Menu = ({
  isOpen,
  subWagerList,
  selectedBetType,
  onSelectBetType,
  betTypeName,
  onClickBack,
  onSelectLegRace,
  activeLeg
}: MenuProps) => {
  const colorTokens = useColorTokens();
  const { colors } = useTheme();

  const menuTransition = useTransition(isOpen, {
    config: { duration: 200 },
    from: { backgroundColor: colors.white["200"], opacity: 1 },
    enter: { backgroundColor: colors.white["900"], opacity: 1 },
    leave: { backgroundColor: colors.white["900"], opacity: 0 }
  });

  const { x } = useSpring({
    from: { x: 0 },
    x: isOpen ? 1 : 0,
    config: { duration: 200 }
  });

  return (
    <>
      {menuTransition(
        (styles, menu) =>
          menu && (
            <AnimatedContainer
              data-qa-label="bet-type-selector-menu"
              style={styles}
            >
              <AnimatedBackButton
                data-qa-label="bet-type-selector-menu-back-button"
                onClick={onClickBack}
                style={{
                  transform: x.to({
                    range: [0, 1],
                    output: ["translateX(-25px)", "translateX(0)"]
                  })
                }}
              >
                <Icon
                  size="m"
                  name="arrowLeft"
                  lineColor={colorTokens.content.subtle}
                />
                <BackTextContainer>
                  <Paragraph
                    qaLabel="bet-type-selector-menu-title"
                    fontSize="12px"
                    textTransform="uppercase"
                    color={colorTokens.content.subtle}
                  >
                    Bet Type
                  </Paragraph>
                  <Paragraph
                    qaLabel="bet-type-selector-menu-active-type"
                    fontFamily="medium"
                    color={colorTokens.content.default}
                  >
                    {betTypeName}
                  </Paragraph>
                </BackTextContainer>
              </AnimatedBackButton>
              <AnimatedList
                style={{
                  transform: x.to({
                    range: [0, 1],
                    output: ["translateX(25px)", "translateX(0)"]
                  })
                }}
                isGroupWagerList={false}
                betTypesList={subWagerList}
                onSelectBetType={(item) => {
                  if (item.legCount > 1) {
                    onSelectLegRace(item.id);
                  } else {
                    onSelectBetType(item.id);
                  }
                }}
                selectedBetType={selectedBetType}
                activeLeg={activeLeg}
              />
            </AnimatedContainer>
          )
      )}
    </>
  );
};

export default Menu;
